var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLocationArrow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.9822 2.57649C21.0908 2.18481 20.6803 1.86069 20.3294 2.06109L3.23328 11.8253C2.98769 11.9655 2.93108 12.285 3.08697 12.497C3.1323 12.5587 3.19832 12.621 3.27073 12.6457C4.21288 12.9671 11.5171 13.5893 11.6044 13.5967C11.6073 13.5969 11.6066 13.5969 11.6095 13.5973C11.7744 13.6187 11.9146 13.7294 11.9748 13.8859C11.9758 13.8884 11.9756 13.8878 11.9765 13.8904C12.0034 13.9703 14.4275 21.1518 14.9178 21.8499C14.9501 21.8959 15.0001 21.9256 15.05 21.9514C15.2967 22.0786 15.613 21.9472 15.6923 21.6612L20.9822 2.57649Z",
    className: "Icon-fill-color",
    stroke: "transparent"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationArrow);
export default __webpack_public_path__ + "static/media/LocationArrow.7c9f8b275e7f609cf8d4092fae20cfed.svg";
export { ForwardRef as ReactComponent };